import { gql } from "@apollo/client";

export default gql`
  query sinTaken($sin: String!) {
    sinTaken(sin: $sin)
  }
`;
